import Popup from './EmailPopup';
export const EmailPopup = Popup;